<template>

    <Head>
        <meta name="title" content="A1 Level English Vocabulary | 1000 Words of Quiz + Pronunciations" />
        <title>A1 Level English Vocabulary | 1000 Words of Quiz + Pronunciations</title>
        <meta name="description"
            content="You can learn A1 level English words with Quiz here. The list consists of 1000 words. Click on the sound icon to listen to the pronunciation of the words.." />
    </Head>
    <div class="container pt-5 mt-3 mb-5">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">

                <h1 class="archivo">A1 Level English Vocabulary | Learn 1000 Words with Quiz + Listen Pronunciations
                </h1>

                <p class="mt-5">Hello, in this blog post, we are sharing <b>A1 level English vocabulary</b> with you.
                    Learning these words will positively impact your English reading, listening, writing, and even
                    speaking skills. Since these are <b>the most commonly used words in English</b>, learning them will
                    help you understand many basic English sentences.</p>

                <p>In the list below, we have provided each word along with its meaning. <b>Our list consists of 1,000
                        words.</b> We’ve also assigned each word a difficulty level from 1 to 9. You can filter the
                    words by difficulty using the difficulty bar. By clicking the sound icon next to each word, you can
                    <b>listen to its pronunciation.</b> Additionally, you can click on the words you know to remove them
                    from the list. Once you finish removing known words, you can start the Word Quiz by clicking the Go
                    to Quiz button.
                </p>

                <p>The artificial intelligence developed by Diziyle Öğren has scanned over 60 English TV shows and
                    movies to identify these essential, commonly used words. <b>The list below consists of A1
                        level English words.</b> As we analyze more TV shows and movies, our list is automatically
                    updated. We will soon share a blog post for more challenging word lists. To be notified when the
                    blog post is published, you can follow us on social media.</p>

                <p>Since you can study the word list with the Quiz below, we have not shared a PDF file. However, if you
                    request the word list as a PDF from our contact page, <b>we will send the PDF to your email
                        address.</b> We hope to be helpful in your English learning journey. Happy studying 😊</p>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>
                <h2 class="archivo mt-4"> A1 Level English Word List </h2>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <SuggestedBlogs></SuggestedBlogs>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },

    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 943, MeanLanguageType: 1 } }).then((response) => {
            this.wordListData = JSON.parse(JSON.stringify(response.data))

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    }
}

</script>